import React, { useContext, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FilterPage } from "../FilterPage";
import { CardsContext } from "../../CardsContext";
import { sendPageViewEvent } from '../../../../utils/utils';

export function BrowsePage({
  browseCards,
  filter,
  filterTitle,
  onToggleWatchLater,
  onBack,
  onSeeAll
}) {
  const { routes } = useContext(CardsContext);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    if(!browseCards?.length) {
      return;
    }

    const browseItem = browseCards.find((browse) => browse.slug === id);

    if(browseItem) {
      browseItem.onSeeAll
        ? browseItem.onSeeAll()
        : onSeeAll(browseItem, false);
      sendPageViewEvent(browseItem.title);
    } else {
      history.push(routes.home);
    }
  }, [browseCards, id, routes, history, onSeeAll]);

  return (
    <FilterPage
      browse
      filter={filter}
      filterTitle={filterTitle}
      onBack={onBack}
      onToggleWatchLater={onToggleWatchLater}
    />
  );
}
